import { Api } from "../config/request";

export default {
  getLifeLineOrderDetails(queryParams) {
    return Api.get(`/b2b/lifeline/order-details?${queryParams}`);
  },
  getLifeLineOrderPriceDetails(queryParams) {
    return Api.get(`/b2b/lifeline/price-details?${queryParams}`);
  },
  refundOrder(body) {
    return Api.post(`/b2b/lifeline/refund-order`, body);
  },
  getLifelineCallLogs(queryParams) {
    return Api.get(`/b2b/lifeline/call-logs?${queryParams}`);
  },
  connectOutgoingCall(body) {
    return Api.post(`/b2b/lifeline/connect-outgoing-call`, body);
  },
  orderActions(body) {
    return Api.post(`/b2b/lifeline/order-actions`, body);
  },
  orderActionReasons() {
    return Api.get(`/b2b/lifeline/action-reasons`);
  },
  addSupportTags(body) {
    return Api.post(`/b2b/lifeline/add-support-tags`, body);
  },
};
